import { useTranslation } from 'react-i18next'
import Button, { ButtonProps } from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { Box } from '@mui/material'

interface BackButtonProps extends ButtonProps {
  content?: string
  loading?: boolean
}

export function PrintFormButton({ content, loading = false, ...props }: BackButtonProps) {
  const { t, i18n } = useTranslation()

  const buttonContent = content ? (i18n.exists(content) ? t(content) : content) : props.children

  return (
    <Button
      {...props}
      disabled={loading || props.disabled}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        ...props.sx
      }}
    >
      <Box
        sx={{
          opacity: loading ? 0.5 : 1,
          filter: loading ? 'blur(0.5px)' : 'none',
          transition: 'opacity 0.3s, filter 0.3s'
        }}
      >
        {buttonContent}
      </Box>
      {loading ? (
        <CircularProgress
          size={16}
          color='inherit'
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-8px',
            marginLeft: '-8px'
          }}
        />
      ) : null}
    </Button>
  )
}

PrintFormButton.defaultProps = {
  children: 'Form.Buttons.Back',
  color: 'primary',
  variant: 'text'
}
